export default "__VITE_PUBLIC_ASSET__06c45277__"